.cm{border:1px solid #ddd;}